import { addOrRemoveCssClass } from '../utils/dom';
import { DyCheckbox } from './dyCheckbox';
import { IInputField } from './dyAbstractInputField';

export class DyToggleButton extends DyCheckbox {
  constructor(config?: IInputField) {
    super(config, 'dy-toggle-button');
  }

  public setValue(value: boolean, silent?: boolean): this {
    super.setValue(value, silent);

    addOrRemoveCssClass(this.getGui(), 'dy-selected', this.getValue()!);

    return this;
  }
}
